/** Resolves a `LocalizedText` value to one plain string for `lang` - falls back to `"en"`, then whichever key is first, so a value is never blank just because `lang` isn't one of its keys. */
export function localize(value, lang) {
    if (typeof value === 'string')
        return value;
    if (lang && value[lang])
        return value[lang];
    if (value.en)
        return value.en;
    const first = Object.values(value)[0];
    return first ?? '';
}
//# sourceMappingURL=i18n.js.map